import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const P231GetDataHead = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.P1Service}p_p1_info_head`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const P231GetColumnList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.SupervisorService}p_supervisor_boq_head_info`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const P231GetDataList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.P1Service}p_p1_info_detail`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const P231UpdateDetailData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.P1Service}p_p1_detail_update`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const P231UpdateData = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios
                .post(URL_API(`${servicelist.P1Service}p_p1_head_update`), body, authorization)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
